import { Injectable, TemplateRef } from '@angular/core';
import { CrmModifiedToastComponent } from './crm-modified-toast.component';
import { CrmModifiedToastOptionsModel } from './crm-modified-toast-options.model';

@Injectable()
export class CrmModifiedToastStateService {
  options!: CrmModifiedToastOptionsModel;
  template!: TemplateRef<CrmModifiedToastComponent>;
}
